<template>
  <div class="payment-container">
    <v-expansion-panel popout
                       light
                       v-if="route !== 'Dashboard' && route !== 'Availability'"
                       class="futuristic-expansion">
      <v-expansion-panel-content>
        <template v-slot:header>
          <div>
            <h4 class="earth-color">GLOBAL SEARCH</h4>
            <div class="title-decoration"></div>
          </div>
        </template>
        <template v-slot:actions>
          <v-icon color="#587e27">$vuetify.icons.expand</v-icon>
        </template>
        <search-tabs v-if="route !== 'Dashboard' && route !== 'Availability'"></search-tabs>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel popout light v-if="route === 'Bookings'" class="futuristic-expansion">
      <v-expansion-panel-content>
        <template v-slot:header>
          <div>
            <h4 class="earth-color">SEARCH PARAMETERS</h4>
            <div class="title-decoration"></div>
          </div>
        </template>
        <v-card flat class="futuristic-card">
          <v-container fluid>
            <v-layout row wrap>
              <v-flex lg2 md3 sm4 xs12>
                <v-container fluid>
                  <v-autocomplete label="Status"
                                  v-model="booking_status_filter"
                                  :items="$findBookingStatus()"
                                  :rules="[(v) => !!v || 'Item is required']"
                                  required
                                  class="futuristic-input"></v-autocomplete>
                </v-container>
              </v-flex>
              <!-- Removed the Booking Type dropdown since we have tabs -->
              <v-flex lg2 md3 sm4 xs12>
                <v-container fluid>
                  <v-autocomplete label="Guest Numbers"
                                  v-model="booking_guest_number_filter"
                                  :items="$findGuestNumbers()"
                                  :rules="[(v) => !!v || 'Item is required']"
                                  required
                                  class="futuristic-input"></v-autocomplete>
                </v-container>
              </v-flex>
              <v-flex lg2 md3 sm4 xs12>
                <v-container>
                  <v-autocomplete label="Booking Source"
                                  v-model="booking_source_filter"
                                  :items="$findBookingSource()"
                                  :rules="[(v) => !!v || 'Item is required']"
                                  required
                                  class="futuristic-input"></v-autocomplete>
                </v-container>
              </v-flex>
              <v-flex lg2 md3 sm4 xs12>
                <v-container>
                  <v-autocomplete label="Destination"
                                  v-model="destination_filter"
                                  :items="$findDestinations()"
                                  :rules="[(v) => !!v || 'Item is required']"
                                  required
                                  class="futuristic-input"></v-autocomplete>
                </v-container>
              </v-flex>
              <v-flex lg2 md3 sm4 xs12>
                <v-container>
                  <v-autocomplete label="Country"
                                  v-model="country_filter"
                                  :items="$findCountries()"
                                  :rules="[(v) => !!v || 'Item is required']"
                                  required
                                  class="futuristic-input"></v-autocomplete>
                </v-container>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-card flat class="futuristic-card">
      <v-card-title class="card-header">
        <div>
          <h4 v-if="route === 'Bookings'" class="earth-color">
            UPCOMING BOOKINGS
          </h4>
          <h4 v-if="route === 'SearchResults'" class="earth-color">
            BOOKINGS SEARCH RESULTS
          </h4>
          <div class="title-decoration"></div>
        </div>
        <v-spacer></v-spacer>
        <v-text-field append-icon="search"
                      label="Search"
                      single-line
                      hide-details
                      v-model="search"
                      class="futuristic-search"></v-text-field>
      </v-card-title>

      <!-- Booking Type Tabs (including "All" tab) -->
      <v-tabs v-model="selectedTypeTab" slider-color="primary" class="type-tabs" v-if="bookingTypes.length > 0">
        <v-tab v-for="(type, index) in bookingTypes" :key="'type-' + index" ripple>
          {{ type.label }} ({{ getTypeCount(type.value) }})
        </v-tab>
      </v-tabs>

      <v-data-table :headers="route === 'Dashboard' ? columns : all_columns"
                    :items="filteredByType"
                    :search="search"
                    :rows-per-page-items="route === 'Dashboard' ? [10, 30, { text: 'All', value: -1 }] : [10, 25, { text: 'All', value: -1 }]"
                    :disable-initial-sort="true"
                    :loading="$loadingTrue"
                    v-if="route === 'Dashboard'"
                    class="futuristic-table">
        <v-progress-linear slot="progress"
                           color="#587e27"
                           indeterminate></v-progress-linear>
        <template v-slot:items="props">
          <td data-label="Created on">{{ formated_date_time(props.item.created_at) }}</td>
          <td data-label="Ref">
            <router-link :to="{
                name: 'Booking',
                params: { booking_id: props.item.booking_public_id },
              }">
              <a class="futuristic-link text-dark">
                <u>{{ props.item.booking_ref_code }}</u>
              </a>
            </router-link>
          </td>
          <td data-label="Client Name">{{ props.item.booking_done_by }}</td>
          <td data-label="Destination">{{ props.item.destination || 'N/A' }}</td>
          <td data-label="Country">{{ props.item.country || 'N/A' }}</td>
          <td data-label="Booking Type">{{ props.item.booking_type }}</td>
          <td data-label="Payment Status">{{ props.item.booking_payment_status }}</td>
          <td data-label="Check In">{{ formated_date(props.item.booking_check_in_date) }}</td>
          <td data-label="Check Out">{{ formated_date(props.item.booking_check_out_date) }}</td>
          <td data-label="Number of Guests">{{ props.item.guest_total }}</td>
          <td data-label="Status" v-bind:style="props.item.booking_color">{{ props.item.booking_status }}</td>
          <td data-label="In-House Status">
            <v-chip :color="props.item.in_house_status_color">{{ props.item.in_house_status }}</v-chip>
          </td>
          <td data-label="Source">{{ props.item.session_user }}</td>
          <td data-label="Action">
            <v-btn :depressed="true"
                   small
                   @click="openBooking(props.item.booking_public_id)"
                   class="futuristic-btn">View Booking</v-btn>
          </td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning" class="futuristic-alert">
          Your search for "{{ search }}" found no results.
        </v-alert>
        <v-alert slot="no-data" :value="true" color="info" icon="info" class="futuristic-alert">
          No bookings found for this type.
        </v-alert>
      </v-data-table>

      <v-data-table :headers="all_columns"
                    :items="filteredByType"
                    :search="search"
                    :rows-per-page-items="[10, 25, { text: 'All', value: -1 }]"
                    :disable-initial-sort="true"
                    :loading="$loadingTrue"
                    no-data-text
                    v-if="route === 'Bookings'"
                    :scroll="getMore"
                    item-key="booking_public_id"
                    class="futuristic-table">
        <v-progress-linear slot="progress" color="#587e27"></v-progress-linear>
        <template v-slot:items="props">
          <tr @click="
              (props.expanded = !props.expanded),
                getTotal(props.item.booking_public_id)
            ">
            <td data-label="Created on">{{ formated_date_time(props.item.created_at) }}</td>
            <td data-label="Ref">
              <router-link :to="{
                  name: 'Booking',
                  params: { booking_id: props.item.booking_public_id },
                }"
                           target="_blank">
                <a class="futuristic-link text-dark">
                  <u>{{ props.item.booking_ref_code }}</u>
                </a>
              </router-link>
            </td>
            <td data-label="Client Name">{{ props.item.booking_done_by }}</td>
            <td data-label="Destination">{{ props.item.destination || 'N/A' }}</td>
            <td data-label="Country">{{ props.item.country || 'N/A' }}</td>
            <td data-label="Booking Type">{{ props.item.booking_type }}</td>
            <td data-label="Check In">{{ formated_date(props.item.booking_check_in_date) }}</td>
            <td data-label="Check Out">{{ formated_date(props.item.booking_check_out_date) }}</td>
            <td data-label="Booking Status" v-bind:style="props.item.booking_color">{{ props.item.booking_status }}</td>
            <td data-label="Payment Status">{{ props.item.booking_payment_status }}</td>
            <td data-label="Source">{{ props.item.session_user }}</td>
            <td data-label="Action">
              <v-btn :depressed="true"
                     small
                     @click="openBooking(props.item.booking_public_id)"
                     class="futuristic-btn">View Booking</v-btn>
            </td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning" class="futuristic-alert">
          Your search for "{{ search }}" found no results.
        </v-alert>
        <v-alert slot="no-data" :value="true" color="info" icon="info" class="futuristic-alert">
          No bookings found for this type.
        </v-alert>
      </v-data-table>

      <div class="text-xs-center"
           v-if="$filterBooking.length <= 0 && route === 'Bookings'">
        <ball-clip-rotate-pulse-loader color="#587e27"
                                       size="50px"></ball-clip-rotate-pulse-loader>
      </div>
      <v-btn v-if="route === 'Bookings'"
             :depressed="true"
             @click="getMore()"
             color="#587e27"
             :loading="this.$store.state.LoadingStore.loading"
             class="futuristic-btn">GET MORE</v-btn>
      <vue-json-excel v-if="route === 'Bookings'"
                      type="xls"
                      worksheet="Bookings Data"
                      :name="
          this.$moment().format('DD-MM-YYYY HH:mm:ss') +
          ' Filtered Report (Beta).xls'
        "
                      :data="filteredByType"
                      :fields="reportFields">
        <v-btn color="#e84118" :depressed="true" class="futuristic-btn">GENERATE REPORT (EXCEL BETA)</v-btn>
      </vue-json-excel>
      <vue-json-excel v-if="route === 'Bookings'"
                      type="csv"
                      worksheet="Bookings Data"
                      :name="
          this.$moment().format('DD-MM-YYYY HH:mm:ss') +
          ' Filtered Report (Beta).csv'
        "
                      :data="filteredByType"
                      :fields="reportFields">
        <v-btn color="#f1c40f" :depressed="true" class="futuristic-btn">GENERATE REPORT (CSV BETA)</v-btn>
      </vue-json-excel>
    </v-card>
  </div>
</template>

<script>
  import SearchTabs from "./FindBooking";
  import VueJsonExcel from "vue-json-excel";

  export default {
    name: "Bookings",
    components: { SearchTabs, VueJsonExcel },

    data() {
      return {
        localData: JSON.parse(localStorage.getItem("unem")),
        search: "",
        destination_filter: null,
        country_filter: null,
        destinations: [],
        countries: [],
        selectedTypeTab: 0, // index of selected booking type, 0 is "All"
        booking_status_filter: null,
        booking_guest_number_filter: null,
        booking_source_filter: null,

        route: this.$route.name,
        AllStreamedBookings: null,
        bookingsTableData: [],
        token: "M2JlMTFiZDUtYWU0OS00NTkzLWI1MjMtZDBlOWVmZmFmZGUz",
        isConnected: false,
        page: 2,

        bookingReportTitle:
          this.$moment().format("DD-MM-YYYY HH:mm:ss a") +
          " Filtered Report (Beta)",

        reportFields: {
          Created_At: {
            field: "created_at",
            callback: (date) => this.report_date_format(date),
          },
          Check_In_Date: {
            field: "booking_check_in_date",
            callback: (date) => this.report_date_format(date),
          },
          Check_Out_Date: {
            field: "booking_check_out_date",
            callback: (date) => this.report_date_format(date),
          },
          Booking_Ref: "booking_ref_code",
          Booking_Type: "booking_type",
          Ticket: "booking_ticket",
          Client_Name: "booking_done_by",
          Destination: "destination",
          Country: "country",
          Status: "booking_status",
          Payment_Status: "booking_payment_status",
          Source: "session_user",
        },

        all_columns: [
          { text: "Created on", value: "created_at" },
          { text: "Ref", value: "booking_ref_code" },
          { text: "Client Name", value: "booking_done_by" },
          { text: "Destination", value: "destination" },
          { text: "Country", value: "country" },
          { text: "Booking Type", value: "booking_type" },
          { text: "Check In", value: "check_in" },
          { text: "Check Out", value: "check_out" },
          { text: "Booking Status", value: "booking_status" },
          { text: "Payment Status", value: "payment_status" },
          { text: "Source", value: "session_user" },
          { text: "Action", value: "" },
        ],

        columns: [
          { text: "Created on", value: "created_at" },
          { text: "Ref", value: "booking_ref_code" },
          { text: "Client Name", value: "booking_done_by" },
          { text: "Destination", value: "destination" },
          { text: "Country", value: "country" },
          { text: "Booking Type", value: "booking_type" },
          { text: "Payment Status", value: "payment_status" },
          { text: "Check In", value: "check_in" },
          { text: "Check Out", value: "check_out" },
          { text: "Number of Guests", value: "guest_total" },
          { text: "Status", value: "booking_status" },
          { text: "In-House Status", value: "in_house_status" },
          { text: "Source", value: "session_user" },
          { text: "Action", value: "" },
        ],
      };
    },

    beforeCreate() {
      this.$store.state.BookingStore.all_bookings = [];
      if (this.$route.name === "Bookings") {
        this.$store.dispatch("get_all_streamed_bookings");
      }
    },

    created() {
      if (
        this.$route.name === "Bookings" &&
        this.localData.user_type_id === "230862f9"
      ) {
        this.$store.dispatch("get_all_streamed_bookings");
      }
    },

    updated() {
      this.route = this.$route.name;
    },

    computed: {
      allBookings() {
        return this.$store.state.BookingStore.all_bookings || [];
      },

      // Compute unique booking types with labels, prepend "All" tab
      bookingTypes() {
        const typesSet = new Set();
        this.allBookings.forEach(b => {
          if (b.booking_type) {
            const t = String(b.booking_type).trim();
            if (t) typesSet.add(t);
          }
        });
        const sorted = Array.from(typesSet).sort();
        // Prepend "All" option
        const result = [{ label: 'All', value: null }];
        sorted.forEach(t => {
          result.push({
            label: this.formatTypeLabel(t),
            value: t
          });
        });
        return result;
      },

      // Get the currently selected type value (null for "All")
      selectedType() {
        if (this.bookingTypes.length === 0) return null;
        const index = this.selectedTypeTab;
        return this.bookingTypes[index] ? this.bookingTypes[index].value : null;
      },

      // Apply all filters (status, guest, source, destination, country, search) and type (if not null)
      filteredByType() {
        let filtered = this.allBookings;

        // Type filter: only apply if selectedType is not null (i.e., not "All")
        if (this.selectedType !== null) {
          filtered = filtered.filter(b => String(b.booking_type).trim() === this.selectedType);
        }

        // Other filters from the search parameters panel
        if (this.booking_status_filter && this.booking_status_filter !== 'No Filter') {
          filtered = filtered.filter(b => b.booking_status === this.booking_status_filter);
        }
        if (this.booking_guest_number_filter && this.booking_guest_number_filter !== 'No Filter') {
          filtered = filtered.filter(b => String(b.guest_total) === this.booking_guest_number_filter);
        }
        if (this.booking_source_filter && this.booking_source_filter !== 'No Filter') {
          filtered = filtered.filter(b => b.session_user === this.booking_source_filter);
        }
        if (this.destination_filter && this.destination_filter !== 'No Filter') {
          filtered = filtered.filter(b => b.destination && b.destination.toLowerCase() === this.destination_filter.toLowerCase());
        }
        if (this.country_filter && this.country_filter !== 'No Filter') {
          filtered = filtered.filter(b => b.country && b.country.toLowerCase() === this.country_filter.toLowerCase());
        }

        return filtered;
      },

      // For backwards compatibility with existing code (used in template for v-if conditions)
      $filterBooking() {
        return this.filteredByType;
      },
    },

    watch: {
      allBookings: {
        handler(newBookings) {
          if (newBookings && newBookings.length > 0) {
            const destinationsSet = new Set();
            const countriesSet = new Set();
            newBookings.forEach((b) => {
              if (b.destination) destinationsSet.add(b.destination);
              if (b.country) countriesSet.add(b.country);
            });
            this.destinations = ["No Filter"].concat([...destinationsSet].sort());
            this.countries = ["No Filter"].concat([...countriesSet].sort());
          }
          // Reset tab if out of bounds (shouldn't happen with "All" always present)
          if (this.selectedTypeTab >= this.bookingTypes.length) {
            this.selectedTypeTab = 0;
          }
        },
        immediate: true,
      },
    },

    props: {
      loading: { type: Boolean, default: true },
      color: { type: String, default: "#587e27" },
      size: { type: String, default: "60px" },
      margin: { type: String, default: "2px" },
      radius: { type: String, default: "100%" },
    },

    methods: {
      getMore() {
        this.loading = true;
        this.$store.dispatch("get_more_streamed_bookings", this.page);
        this.page++;
      },

      $findDestinations() {
        let unique = new Set();
        const bookingsData = this.allBookings;
        bookingsData.forEach((b) => {
          if (b.destination) unique.add(b.destination);
        });
        return ["No Filter"].concat([...unique].sort());
      },

      $findCountries() {
        let unique = new Set();
        const bookingsData = this.allBookings;
        bookingsData.forEach((b) => {
          if (b.country) unique.add(b.country);
        });
        return ["No Filter"].concat([...unique].sort());
      },

      // These are expected by the template (global mixin methods)
      $findBookingStatus() {
        // return a list of statuses from data or a default list
        const statuses = new Set();
        this.allBookings.forEach(b => {
          if (b.booking_status) statuses.add(b.booking_status);
        });
        return ["No Filter"].concat([...statuses].sort());
      },

      $findGuestNumbers() {
        const guests = new Set();
        this.allBookings.forEach(b => {
          if (b.guest_total) guests.add(String(b.guest_total));
        });
        return ["No Filter"].concat([...guests].sort());
      },

      $findBookingSource() {
        const sources = new Set();
        this.allBookings.forEach(b => {
          if (b.session_user) sources.add(b.session_user);
        });
        return ["No Filter"].concat([...sources].sort());
      },

      openBooking(publicId) {
        this.$router.push({
          name: "Booking",
          params: { booking_id: publicId },
        });
      },

      getTotal(publicId) {
        if (this.$store.state.BookingStore.booking_cost.booking_id !== publicId) {
          this.$store.dispatch("get_single_booking_total_cost", publicId);
        }
      },

      formatTypeLabel(type) {
        return String(type)
          .toLowerCase()
          .split(' ')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ');
      },

      getTypeCount(type) {
        if (type === null) {
          // "All" tab: return total bookings
          return this.allBookings.length;
        }
        return this.allBookings.filter(b => String(b.booking_type).trim() === type).length;
      },

      // Utility date formatting (copied from original)
      formated_date(date) {
        if (!date) return 'N/A';
        try {
          return new Date(date).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
          });
        } catch (e) {
          return 'Invalid Date';
        }
      },
      report_date_format(date) {
        if (!date) return '';
        try {
          return new Date(date).toLocaleDateString('en-US');
        } catch (e) {
          return '';
        }
      },
    },
  };
</script>

<style scoped>
  /* Futuristic Container */
  .payment-container {
    background: #ffffff;
    border-radius: 8px;
    padding: 16px;
    transition: all 0.3s ease;
  }

    .payment-container:hover {
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
    }

  .card-header {
    background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
    padding: 16px;
    border-radius: 8px;
  }

  .earth-color {
    color: #587e27;
    font-weight: 600;
    margin: 0;
    font-size: 1.5rem;
  }

  .title-decoration {
    height: 4px;
    background: linear-gradient(90deg, #587e27, transparent);
    margin-bottom: 16px;
    width: 100px;
  }

  .futuristic-card {
    border-radius: 8px;
    background: #ffffff;
    transition: all 0.3s ease;
  }

    .futuristic-card:hover {
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
    }

  .futuristic-expansion {
    border-radius: 8px;
    background: #ffffff;
    transition: all 0.3s ease;
  }

    .futuristic-expansion:hover {
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
    }

  .futuristic-input > > > .v-input__slot {
    border-radius: 8px;
    background: #f5f7fa;
  }

  .futuristic-btn {
    border-radius: 8px;
    text-transform: none;
    font-weight: 500;
    transition: all 0.2s ease;
  }

    .futuristic-btn:hover {
      transform: translateY(-1px);
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    }

  .futuristic-table {
    border-radius: 8px;
    background: #ffffff;
  }

    .futuristic-table > > > th {
      color: #587e27;
      font-weight: 600;
    }

  .futuristic-link {
    color: #587e27;
    text-decoration: none;
    transition: color 0.2s ease;
  }

    .futuristic-link:hover {
      color: #1b5e20;
    }

  .futuristic-alert {
    border-radius: 8px;
    background: #fff5f5;
  }

  .futuristic-search > > > .v-input__slot {
    border-radius: 8px;
    background: #f5f7fa;
  }

  /* Booking type tabs */
  .type-tabs .v-tabs__bar {
    background: linear-gradient(45deg, #f5f7fa, #e8eaf6);
    margin: 0 8px;
    border-radius: 8px 8px 0 0;
  }

  .type-tabs .v-tabs__item {
    font-size: 0.85rem;
    font-weight: 500;
    color: #587e27;
    text-transform: none;
  }

  .type-tabs .v-tabs__item--active {
    background: rgba(88, 126, 39, 0.1);
  }

  /* Responsive adjustments */
  @media (max-width: 960px) {
    .payment-container {
      padding: 12px;
    }

    .card-header {
      padding: 12px;
    }

    .earth-color {
      font-size: 1.25rem;
    }

    .futuristic-btn {
      font-size: 0.9rem;
    }

    .type-tabs .v-tabs__item {
      font-size: 0.8rem;
      padding: 0 8px;
    }
  }

  @media (max-width: 600px) {
    .payment-container {
      padding: 8px;
      border-radius: 6px;
    }

    .card-header {
      padding: 8px;
    }

    .earth-color {
      font-size: 1.1rem;
    }

    .futuristic-btn {
      font-size: 0.85rem;
    }

    .type-tabs .v-tabs__wrapper {
      overflow-x: auto;
    }

    .type-tabs .v-tabs__container {
      min-width: 500px;
    }

    .type-tabs .v-tabs__item {
      font-size: 0.75rem;
      padding: 0 6px;
      min-width: auto;
    }

    .futuristic-table table {
      min-width: 700px;
    }
  }
</style>
